import React, { useCallback, useEffect, useRef, useState } from "react"
import { CSSTransition } from "react-transition-group"
import { StyledComponent } from "@rogue_4/types"
import anime from "animejs"
import classNames from "classnames"

import ANIMATION from "../../../animation"
import { useDivRef } from "../../../hooks/useDivRef"
import { IGameItem } from "../../../type"
import { SFX } from "../../../utils/sound"
import { getTransitionClassnames } from "../../../utils/transition"
import ModalTitle from "../common/modalTitle"
import { useGameModalStore } from "../store"

import styles from "./index.module.less"

const ItemModal: StyledComponent = ({ className, style }) => {
    const [item, setItem] = useState<IGameItem>()
    const [active, setActive] = useState(false)
    const containerRef = useDivRef()
    const decoRef = useDivRef()
    const imageRef = useDivRef()
    const titleRef = useDivRef()
    const contentRef = useDivRef()
    const backRef = useDivRef()

    const cbRef = useRef<() => void>()

    const loadingRef = useRef(false)
    useEffect(() => {
        //需改回
        useGameModalStore.setState({
            callItemModal: (item, immediate, cb) => {
                cbRef.current = cb
                setItem(item)
                loadingRef.current = true
                setActive(true)
                // anime
                //     .timeline()
                //     .add(
                //         ANIMATION.in(
                //             [decoRef, imageRef],
                //             {
                //                 bottom: "20rem",
                //                 immediate,
                //             },
                //             {
                //                 duration: 8,
                //             }
                //         ),
                //         0
                //     )
                //     .add(
                //         ANIMATION.in(
                //             titleRef,
                //             {
                //                 bottom: "1rem",
                //                 immediate,
                //             },
                //             { duration: 5 }
                //         ),
                //         immediate ? 0 : 10
                //     )
                //     .add(
                //         ANIMATION.in(
                //             contentRef,
                //             {
                //                 bottom: "1rem",
                //                 immediate,
                //             },
                //             { duration: 5 }
                //         ),
                //         immediate ? 0 : 10
                //     )
                //     .add(
                //         ANIMATION.in(
                //             backRef,
                //             {
                //                 // bottom: "2rem",
                //                 immediate,
                //             },
                //             { duration: 50 }
                //         ),
                //         immediate ? 0 : 13
                //     )
                //     .finished.then(() => {
                //         loadingRef.current = false
                //     })
                anime
                    .timeline()
                    .add(
                        ANIMATION.in(
                            [decoRef, imageRef],
                            {
                                bottom: "20rem",
                                immediate,
                            },
                            {
                                duration: 800,
                            }
                        ),
                        0
                    )
                    .add(
                        ANIMATION.in(
                            titleRef,
                            {
                                bottom: "1rem",
                                immediate,
                            },
                            { duration: 500 }
                        ),
                        immediate ? 0 : 1000
                    )
                    .add(
                        ANIMATION.in(
                            contentRef,
                            {
                                bottom: "1rem",
                                immediate,
                            },
                            { duration: 500 }
                        ),
                        immediate ? 0 : 1000
                    )
                    .add(
                        ANIMATION.in(
                            backRef,
                            {
                                // bottom: "2rem",
                                immediate,
                            },
                            { duration: 500 }
                        ),
                        immediate ? 0 : 1300
                    )
                    .finished.then(() => {
                        loadingRef.current = false
                    })
            },
        })
    }, [])

    const handleBack = useCallback((e: React.MouseEvent) => {
        SFX.play("commonClick")
        e.stopPropagation()
        cbRef.current?.()
        setActive(false)
    }, [])
    return (
        //需改回
        <CSSTransition
            in={active}
            // timeout={30}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                ref={containerRef}
                className={classNames(styles.itemModal, className)}
                style={style}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className={styles.deco} ref={decoRef}></div>
                <div
                    ref={imageRef}
                    className={classNames(
                        styles.image,
                        item?.["type"] && styles.mask
                    )}
                    style={{ backgroundImage: `url(${item?.image})` }}
                ></div>
                <ModalTitle ref={titleRef} className={styles.title}>
                    {item?.name}
                </ModalTitle>
                <div ref={contentRef} className={styles.content}>
                    {item?.description.split("\n").map((s) => (
                        <div key={s} className={styles.line}>
                            {s}
                        </div>
                    ))}
                </div>
                <div
                    ref={backRef}
                    className={styles.backButton}
                    onClick={handleBack}
                ></div>
            </div>
        </CSSTransition>
    )
}

export default ItemModal
